import * as types from '../../mutationTypes'
const state = {
  consoleTipsList: {
    consoleTips: [],
    consoleTipsBusiness: []
  },
  pageCache: {}, // 页面数据
  tipsActive: 'weight' // 激活的说明页
}

const mutations = {
  [types.SET_CONSOLE_TIPS_LIST] (state, data) {
    state.consoleTipsList = data
  },
  [types.SET_PAGE_CACHE] (state, data) {
    state.pageCache = data
  },
  [types.SET_TIPS_ACTIVE] (state, data) {
    state.tipsActive = data
  }
}

const actions = {
  setConsoleTipsList ({ commit }, data) {
    commit(types.SET_CONSOLE_TIPS_LIST, data)
  },
  setPageCache ({ commit }, data) {
    commit(types.SET_PAGE_CACHE, data)
  },
  setTipsActive ({ commit }, data) {
    commit(types.SET_TIPS_ACTIVE, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
